export default "__VITE_ASSET__DhAsm5SA__"